import { render, staticRenderFns } from "./TaskStats.vue?vue&type=template&id=186d5266"
import script from "./TaskStats.vue?vue&type=script&lang=js"
export * from "./TaskStats.vue?vue&type=script&lang=js"
import style0 from "./TaskStats.vue?vue&type=style&index=0&id=186d5266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports